import React from "react";
import { Music, Star, Users, Mic, Clock, CalendarDays } from "lucide-react";
import { useLanguage } from "../../contexts/LanguageContext";

const ArtistsSection: React.FC = () => {
  const { t } = useLanguage();

  const artists = [
    {
      name: "CARMEN ȘERBAN",
      role: "guestArtistFemale",
      icon: <Star className="w-6 h-6 text-white" />,
    },
    {
      name: "DAN CIOTOI",
      role: "guestArtist",
      icon: <Star className="w-6 h-6 text-white" />,
    },
    {
      name: "ION PALADI",
      role: "guestArtist",
      icon: <Star className="w-6 h-6 text-white" />,
    },
    {
      name: "FORMAȚIA ELEGANCE TORINO",
      role: "localBand",
      icon: <Music className="w-6 h-6 text-white" />,
    },
    {
      name: "GRUPUL VATRA",
      role: "folkEnsemble",
      icon: <Users className="w-6 h-6 text-white" />,
    },
    {
      name: "LUIZA DICULESCU",
      role: "presenter",
      icon: <Mic className="w-6 h-6 text-white" />,
    },
  ];

  return (
    <section className="section bg-gray-50 overflow-hidden">
      <div className="container-custom">
        {/* Muzică și dans */}
        <div>
          <div className="text-center mb-12">
            <span className="text-romanian-red font-semibold text-sm uppercase tracking-wider">
              {t.experience.artisticProgram}
            </span>
            <h2 className="font-display text-3xl md:text-4xl font-bold text-romanian-blue mt-2 mb-4">
              {t.experience.musicAndDance}
            </h2>
            <div className="w-24 h-1 bg-gradient-to-r from-romanian-blue via-romanian-yellow to-romanian-red mx-auto mb-6" />
            <p className="text-gray-600 max-w-3xl mx-auto">
              {t.experience.musicDesc1}
              <span className="block mt-2 font-semibold text-romanian-blue">
                {t.experience.musicDesc2}
              </span>
            </p>
          </div>

          {/* Artists Section with Image */}
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            {/* Artists List */}
            <div className="order-2 lg:order-1">
              <div className="space-y-4">
                {artists.map((artist, index) => (
                  <div
                    key={index}
                    className="group flex items-center gap-4 bg-white rounded-xl p-5 shadow-md hover:shadow-xl transition-all duration-300 border-l-4 border-romanian-blue hover:border-romanian-red"
                  >
                    <div className="w-12 h-12 bg-gradient-to-br from-romanian-blue to-primary-600 rounded-full flex items-center justify-center flex-shrink-0 group-hover:scale-110 transition-transform">
                      {artist.icon}
                    </div>
                    <div className="flex-1">
                      <h3 className="font-bold text-gray-900 text-xl tracking-wide">
                        {artist.name}
                      </h3>
                      <p className="text-sm text-romanian-blue font-medium">
                        {t.experience[artist.role as keyof typeof t.experience]}
                      </p>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* Artists Image */}
            <div className="order-1 lg:order-2 relative">
              <div className="rounded-2xl overflow-hidden shadow-2xl">
                <img
                  src="/cantanti.jpg"
                  alt={t.experience.artistsAtFestival}
                  className="w-full h-auto object-contain"
                />
              </div>
            </div>
          </div>

          {/* Schedule Image */}
          <div className="mt-16">
            <div className="text-center mb-8">
              <div className="inline-flex items-center gap-2 bg-romanian-blue/10 text-romanian-blue px-4 py-2 rounded-full mb-4">
                <Clock className="w-5 h-5" />
                <span className="font-semibold text-sm uppercase tracking-wider">
                  {t.experience.scheduleLabel}
                </span>
              </div>
              <h3 className="font-display text-2xl md:text-3xl font-bold text-romanian-blue mb-4">
                {t.experience.scheduleTitle}
              </h3>
              <div className="flex items-center justify-center gap-2 max-w-2xl mx-auto text-gray-600">
                <CalendarDays className="w-5 h-5 text-romanian-red flex-shrink-0" />
                <p className="text-sm">{t.experience.scheduleDesc}</p>
              </div>
            </div>
            <div className="max-w-4xl mx-auto rounded-2xl overflow-hidden shadow-2xl border-4 border-romanian-blue/10">
              <img
                src="/orario.png"
                alt={t.experience.scheduleImageAlt}
                className="w-full h-auto object-contain"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ArtistsSection;
